import { appStore } from "../../state/store";
export class ActorAnalysis {
    constructor(app) {
        this.app = app;
        // Default to Bob for the initial demo view
        this.selectedActorUuid = "user-uuid-bob-002";
    }
    render() {
        const state = appStore.getState();
        const team = state.team;
        const fingerprintData = state.premiumState.multiScalarAnalyticalRepresentations.actorFingerprints[this.selectedActorUuid];
        if (!fingerprintData) {
            return `<div class="error">No analytical data found for selected user.</div>`;
        }
        const actorOptions = team.map(t => `<option value="${t.uuid}" ${this.selectedActorUuid === t.uuid ? 'selected' : ''}>${t.name}</option>`).join('');
        const natureChart = `
            <div class="mermaid">
            pie
                "Creative": ${fingerprintData.nature.creative}
                "Logistical": ${fingerprintData.nature.logistical}
                "Unblocking": ${fingerprintData.nature.unblocking}
                "Finishing": ${fingerprintData.nature.finishing}
            </div>
        `;
        const actionsChart = `
            <div class="mermaid">
            %%{init: {'theme':'dark'}}%%
            xychart-beta
                x-axis [${fingerprintData.actions.map(a => `"${a.name}"`).join(',')}]
                y-axis "Count"
                bar [${fingerprintData.actions.map(a => a.count).join(',')}]
            </div>
        `;
        return `
            <div class="analytics-stratum">
                <div class="governing-principle">
                    <h4>Governing Principle: Archetypal Classification & Behavioral Signature Analysis</h4>
                    <p>Deconstructs an individual's "Total Impact" into its constituent parts, revealing the <em>how</em> behind their <em>what</em> to generate a data-driven "fingerprint" of their contribution style.</p>
                </div>

                <div class="form-group">
                    <label for="actor-select">Select Actor to Analyze:</label>
                    <select id="actor-select">${actorOptions}</select>
                </div>
                
                <div class="chart-grid">
                    <div class="chart-container">
                        <h3>Contribution Nature (Impact-Weighted)</h3>
                        ${natureChart}
                    </div>
                    <div class="chart-container">
                        <h3>Primary Actions (Frequency)</h3>
                        ${actionsChart}
                    </div>
                </div>

                <div class="system-insight">
                    <h4>System Insight</h4>
                    <p>${fingerprintData.archetypeInsight}</p>
                </div>
            </div>
        `;
    }
    attachEventListeners() {
        const select = document.getElementById('actor-select');
        select === null || select === void 0 ? void 0 : select.addEventListener('change', (e) => {
            this.selectedActorUuid = e.target.value;
            this.app.renderCurrentView();
        });
        if (typeof window.mermaid !== 'undefined') {
            window.mermaid.run({ nodes: document.querySelectorAll('.mermaid') });
        }
    }
}
